<template>
  <div class="public-resource-templace">
    <div class="safe-area_width_2 register_ad_bg" @click="openRegister">
      <img :src="`${imgPath}/oneold/layout/register_ad_bg.png`" alt="" />
    </div>
    <div class="safe-area_width_2 pt--10 pb--20 f-layout">
      <span>您当前位置：</span>
      <div class="f-layout current-localtion">
        <a href="/" class="hover-text_theme">千里马招标网 &gt; </a>
        <p v-for="item in currentLocation" :key="item.id" class="single">
          <a :href="item.noClick ? 'javascript:;' : item.url" :class="item.noClick ? 'theme-color' : 'hover-text_theme'"
            >{{ item.text }}
          </a>
          <span class="arrow">&gt;</span>
        </p>
      </div>
    </div>
    <!-- 筛选器 start -->
    <TopFilter :area-id="areaId"></TopFilter>

    <!-- 筛选器 end -->

    <!-- 内容区域 start -->
    <div class="content f-layout safe-area_width_2 mt--20">
      <div class="left mr--20">
        <slot></slot>
        <div class="classification default-border mt--20">
          <div class="moudle-title01 mb--20">
            <span class="text">相关网站</span>
          </div>
          <div v-if="pageType === 'gjxx'" class="mb--30">
            <p class="mb--10">{{ includesAreaName }}{{ keyword }}{{ typesName || "" }}介绍：</p>
            <p class="introduce-text ml--40 related-websites-con-text">
              {{ includesAreaName }}{{ keyword }}{{ typesName }}为您提供最新、最全、覆盖最广的{{ typesName }}信息，是{{
                shengAreaName
              }}地区、{{ shengAreaName }}招标单位、{{ shengAreaName }}业主{{
                typesName
              }}的首选平台，在这里您可以查看和发布{{ shengAreaName
              }}{{ keyword }}招投标采购信息，与招投单位直接联系，提升中标率。您还可以直接访问<a
                :href="wapIndexUrl"
                style="color: red"
                >千里马招标网移动端</a
              >，更方便，更快捷。
            </p>
          </div>
          <div v-if="otherObj.areaOther" class="mb--20">
            <p class="mb--10">各地区招标信息：</p>
            <div class="related-websites-con-text ml--30">
              <a
                v-for="item in otherObj.areaOther"
                :key="item.areaid"
                :href="`/gjxx/${otherObj.wId}_${item.areaid}_4`"
                class="single-link hover-text_theme"
                target="_blank"
                >{{ item.name }}{{ otherObj.keyword }}招标信息</a
              >
            </div>
          </div>
          <div v-if="otherObj.areaOther" class="mb--20">
            <p class="mb--10">地区招标网：</p>
            <div class="related-websites-con-text ml--30">
              <a
                v-for="item in otherObj.areaOther"
                :key="item.areaid"
                :href="`${indexUrl}/zb/area_${item.areaid}`"
                class="single-link hover-text_theme"
                target="_blank"
                >{{ item.name }}招标网</a
              >
            </div>
          </div>
        </div>
        <div v-if="friendLinks" class="classification friend-links default-border mt--20">
          <div class="moudle-title01 mb--20">
            <span class="text">友情连接</span>
          </div>
          <a
            v-for="item in friendLinks"
            :key="item.name"
            :href="item.url"
            target="_blank"
            class="hover-text_theme friend-links-a"
            >{{ item.name }}</a
          >
        </div>
        <div class="classification default-border mt--20 f-v-center">
          <div class="moudle-title01 mr--10">
            <span class="text">按字母分类</span>
          </div>
          <a
            v-for="item in classifications"
            :key="item.text"
            :href="item.url"
            target="_blank"
            class="hover-text_theme single-linka"
            >{{ item.text }}</a
          >
        </div>
      </div>
      <div class="right ml--10">
        <div class="moule moudle1 default-border">
          <img :src="`${imgPath}/oneold/layout/reg.png`" alt="" class="top-img" />
          <div class="services f-layout">
            <div v-for="item in registerEnjoyService" :key="item.text" class="single f-v-center">
              <img :src="item.img" alt="" class="icon-img mr--10" />
              <span>{{ item.text }}</span>
            </div>
          </div>
          <div class="bottom-block">
            <el-button type="danger" class="btn theme-color_bg width-100 mb--10" @click="showRegister"
              >立即注册</el-button
            >
            <p class="login-text">
              <span>已有账号，</span>
              <a :href="memberCenterUrl" target="_blank" class="theme-color">登录</a>
            </p>
          </div>
        </div>
        <Substation class="moule moule2">
          <template #title>
            <div class="moudle-title01">
              <span class="text">快速查看各地区招标信息</span>
            </div>
          </template>
        </Substation>
        <div class="moule moule3 default-border">
          <div class="moudle-title01 mb--10">
            <span class="text">{{ keyword }}{{ typesName }}热门行业</span>
          </div>
          <div class="hot-block">
            <a
              v-for="item in hotIndustry"
              :key="item.text"
              :href="`/gjxx/${item.id}_2703_4`"
              class="single-link hover-text_theme"
              >{{ item.text }}</a
            >
          </div>
        </div>
        <div class="moule moule4 default-border">
          <div class="moudle-title01 mb--10">
            <span class="text">{{ includesAreaName }}政府机构</span>
          </div>
          <a
            v-for="item in governmentOrgans"
            :key="item.id + item.text"
            :href="
              item.type === 'hot'
                ? `${indexUrl}/hot${item.id}${areaIdd}/`
                : `${indexUrl}/${item.id}${areaIdd}${item.type}`
            "
            class="single-link hover-text_theme single-link-line"
            target="_blank"
            >{{ includesAreaName }}{{ item.text }}</a
          >
        </div>
        <div class="moule moule5 default-border">
          <div class="moudle-title01 mb--10">
            <span class="text">{{ includesAreaName }}招标推荐</span>
          </div>
          <a
            v-for="item in biddingRecommendation"
            :key="item.id + item.text"
            :href="
              item.type === 'hot'
                ? `${indexUrl}/hot${item.id}${areaIdd}/`
                : `${indexUrl}/${item.id}${areaIdd}${item.type}`
            "
            class="single-link hover-text_theme single-link-line"
            target="_blank"
            >{{ includesAreaName }}{{ item.text }}</a
          >
        </div>
        <div v-if="otherObj.purchasingAgency" class="moule moule6 default-border">
          <div class="moudle-title01 mb--10">
            <span class="text">{{ includesAreaName }}采购机构</span>
          </div>
          <a
            v-for="item in otherObj.purchasingAgency"
            :key="item.id"
            :href="`${indexUrl}/common/agents_info.jsp?id=${item.id}`"
            class="single-link hover-text_theme single-link-line"
            target="_blank"
            >{{ item.name }}</a
          >
        </div>
        <div v-if="otherObj.wholeCountryCNXH || otherObj.nationalGuessYouLike" class="moule moule7 default-border">
          <div class="moudle-title01 mb--10">
            <span class="text">招标热点</span>
          </div>
          <div class="hot-block">
            <a
              v-for="item in otherObj.wholeCountryCNXH || otherObj.nationalGuessYouLike"
              :key="item.id"
              :href="`/gjxx/${item.id}_2703_4`"
              class="single-link hover-text_theme"
              target="_blank"
              >{{ item.name }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 内容区域 ned -->
  </div>
</template>
<script>
import {
  imgPath,
  ossPath,
  INDEX_URL_GJXX,
  WAP_INDEX_URL,
  VUE_APP_OLD_USER_CENTER_URL,
} from "@/utils/constants/constants";
import { formatCurrentLocationUrl } from "@/utils/common";
import {
  biddingRecommendation,
  governmentOrgans,
  hotIndustry,
  registerEnjoyService,
  classifications,
} from "@/utils/constants/gjxx_data_moudle";
import TopFilter from "./TopFilter";
import Substation from "./Substation";
export default {
  name: "PublicResourceTemplace",
  components: {
    TopFilter,
    Substation,
  },
  data() {
    return {
      username: "",
      CDN: ossPath,
      imgPath,
      bannerShow: true,
      show: false,
      pageType: "gjxx",
      biddingRecommendation,
      governmentOrgans,
      hotIndustry,
      registerEnjoyService,
      wapIndexUrl: WAP_INDEX_URL,
      memberCenterUrl: VUE_APP_OLD_USER_CENTER_URL, //会员中心地址
      indexUrl: INDEX_URL_GJXX,
    };
  },
  computed: {
    otherObj() {
      //todo:数据后端给的
      return this.$store.getters["gjxx/otherObj"];
    },
    listObject() {
      //todo:数据后端给的
      return this.$store.getters["gjxx/listObj"];
    },
    classifications() {
      return classifications;
    },
    friendLinks() {
      return this.otherObj.friendLinks || [];
    },
    currentLocation() {
      let otherObj = this.otherObj;
      let list = [
        {
          id: otherObj.areaIdd,
          url: `${INDEX_URL_GJXX}/zb/area_${otherObj.areaIdd}`,
          text: otherObj.areaName + "招标网",
        },
        {
          id: otherObj.shengNameId,
          ...formatCurrentLocationUrl({
            title: this.listObject.title,
          }),
        },
        {
          id: otherObj.shiId,
          ...formatCurrentLocationUrl({
            title: this.listObject.title,
          }),
        },
        {
          id: otherObj.areaId,
          noClick: true,
          ...formatCurrentLocationUrl({
            title: this.listObject.title,
          }),
        },
      ].filter((item) => item.id);

      if (otherObj.areaId === 2703) {
        list.shift();
      }
      return list;
    },
    shengAreaName() {
      return this.otherObj.areaName || "";
    },
    includesAreaName() {
      return this.shengAreaName === "全国" ? "" : this.shengAreaName;
    },
    areaIdd() {
      return this.otherObj.areaIdd || "";
    },
    areaId() {
      return this.otherObj.areaId || "";
    },
    keyword() {
      return this.otherObj.keyword || "";
    },
    typesName() {
      return this.otherObj.typesName || "";
    },
  },
  created() {},
  mounted() {},
  methods: {
    openRegister() {
      this.$emit("register");
    },
    showRegister() {
      this.$emit("register");
    },
  },
};
</script>

<style lang="scss">
.public-resource-templace {
  .register_ad_bg {
    height: 70px;
    //background: url("@/assets/images/layout/register_ad_bg.png") no-repeat;
    margin-bottom: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .seize-a-seat {
    // 待删除
    height: 200px;
  }

  .left {
    // flex: 1;
    width: 844px;
  }

  .right {
    width: 290px;
  }

  .moule {
    margin-bottom: 20px;
    padding: 10px;
  }

  .moudle1 {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    .top-img {
      width: 100%;
    }

    .services {
      flex-wrap: wrap;
      padding: 20px;
    }

    .single {
      width: 50%;
      margin-bottom: 20px;
    }

    .icon-img {
      width: 16px;
      height: 16px;
      vertical-align: center;
    }

    .bottom-block {
      padding: 0 20px;
    }

    .login-text {
      color: #999999;
      text-align: right;

      span {
        &:last-child {
          cursor: pointer;
        }
      }
    }
  }

  .single-link {
    display: inline-block;
    padding: 10px;
  }

  .classification {
    padding: 10px;
    font-size: 14px;

    .single-linka {
      margin: 0 8px;
    }
  }

  .single-link-line {
    display: block;
  }

  .introduce-text {
    line-height: 24px;
  }

  .related-websites-con-text {
    color: #666666;
    a {
      color: #666666;
    }
  }

  .current-localtion {
    .single {
      margin-left: 4px;

      &:last-child .arrow {
        display: none;
      }
    }

    .arrow {
      margin-left: 4px;
    }
  }

  .friend-links-a {
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }
}
</style>
